import { CardGroup, Translation } from '@ridango/core';

export const adult:CardGroup = {
    id: null,
    group_id: '',
    name: 'Adult',
    translations: [
        Object.assign( <Translation> {}, {
            lang: 'en',
            field: 'name',
            translation: 'Adult'
        } ),
        Object.assign( <Translation> {}, {
            lang: 'sv',
            field: 'name',
            translation: 'Vuxen',
        } ),
        Object.assign( <Translation> {}, {
            lang: 'lt',
            field: 'name',
            translation: 'Suaugęs'
        } ),
        Object.assign( <Translation> {}, {
            lang: 'ru',
            field: 'name',
            translation: 'Для взрослых'
        } ),
    ]
};
